import { render, staticRenderFns } from "./upgrade_purchase.vue?vue&type=template&id=5fc17335&"
import script from "./upgrade_purchase.vue?vue&type=script&lang=js&"
export * from "./upgrade_purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports